import { FunctionComponent, useEffect, useState } from 'react'
import { Row, Col, Spin, Card } from 'antd'
import { APICallType, useAPICall } from '../../common'
import { API_URLs } from '../../configuration/api-urls'
import './php-providers-profiles.scss'
import {providerProfiles} from './provider_constants'
import { schedulingImage} from '../../assets'

interface Provider {
  id: string
  firstName: string
  lastName: string
  specialty: string
  email: string
  phoneNumber: string
  bio: string
  imageUrl?: string
}

const PHPProvidersProfiles: FunctionComponent = () => {
  const [providers, setProviders] = useState<Provider[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const { apiCall } = useAPICall()

  useEffect(() => {
    loadProviders()
  }, [])

  const loadProviders = async () => {
    try {
      setLoading(true)
      setError(null)
      console.log('Fetching providers from:', API_URLs.v1.GET_ProvidersProfiles)
      const response: any = await apiCall(
        API_URLs.v1.GET_ProvidersProfiles,
        APICallType.GET
      )
      console.log('Providers response:', response)
      
      // Handle different response formats
      if (Array.isArray(response)) {
        setProviders(response)
      } else if (response && response.data && Array.isArray(response.data)) {
        setProviders(response.data)
      } else {
        console.warn('Unexpected response format:', response)
        setProviders([])
      }
    } catch (err: any) {
      console.error('Error loading providers:', err)
      const errorMsg = err.response?.data?.message || err.message || 'Failed to load providers'
      setError(`${errorMsg} (Status: ${err.response?.status || 'Network Error'})`)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spin size="large" />
      </div>
    )
  }


  return (
    <div className="providers-profiles-container">
      <Row className="p-8 pt-32" justify="center">
        <Col xs={24} sm={22} md={20} lg={18} xl={16}>
          <h1 className="text-3xl font-bold mb-6">
						PHP Behavioral Health Concierge Provider Profiles
          </h1>
        </Col>
      </Row>
      <Row lassName="p-8" justify="center">
        <p>
          <a 
            href="https://forms.office.com/r/yEjJfHEGtm"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={schedulingImage} />
          </a>
        </p>
      </Row>
      <Row gutter={[16, 16]} className="px-8 pb-8" justify="center">
  <Col xs={24} sm={22} md={20} lg={18} xl={16}>
    {providerProfiles.map((provider) => (
      <Card
        key={`${provider.firstName}-${provider.lastName}`}
        hoverable
        className="provider-card mb-4"
      >
        <div className="flex gap-6">
          {provider.imageUrl ? (
            <img
              alt={`${provider.firstName} ${provider.lastName}`}
              src={provider.imageUrl}
              className="provider-image-vertical"
            />
          ) : (
            <div className="provider-image-placeholder-vertical">
              {provider.firstName.charAt(0)}
              {provider.lastName.charAt(0)}
            </div>
          )}
          <div className="flex-1">
            <h2 className="text-2xl font-bold">
              {provider.firstName} {provider.lastName}
            </h2>
            <div className="provider-details">
            <p className="provider-specialty">{provider.experience}</p>  
            <p className="provider-specialty">{provider.target}</p>
            <br />
            </div>
           
          </div>
        </div>
        <div className="flex-1  whitespace-pre-line"> <p className="provider-bio mt-3">{provider.bio}</p></div> 
      </Card>
    ))}
  </Col>
</Row>
<Row lassName="p-8" justify="center">
        <p>
          <a 
            href="https://forms.office.com/r/yEjJfHEGtm"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={schedulingImage} />
          </a>
        </p>
      </Row>
    </div>
  )
}

export default PHPProvidersProfiles
